import axios from '@/utils/request'

/**
 * get企业列表
 */
const getCompanyList = (params, options) => axios({
  url: 'enterprise',
  params,
  options
})

/**
 * 访客记录
 */
const getVisitorList = (params, options) => axios({
  url: 'enterprise/visitor',
  params,
  options
})

/**
 * 拜访申请记录详情
 */
const getVisitorDetails = uuid => axios({
  url: `enterprise/visitor/details/${uuid}`
})

/**
 * 企业详情
 */
const getCompanyDetails = uuid => axios({
  url: `enterprise/${uuid}`
})

/**
 * 企业用户列表
 */
const getCompanyUserList = (data) => axios({
  url: `enterprise/user/${data.uuid}?pageSize=${data.pageSize}&pageIndex=${data.pageIndex}&status=${data.status}&word=${data.word}`
})

/**
 * 企业用户信息
 */
const getCompanyUserDetails = uuid => axios({
  url: `enterprise/user/information/${uuid}`
})

/**
 * 下载导入用户Excel模板
 */
const getExcel = (uuid) => axios({
  url: `enterprise/user/excel/${uuid}`,
  responseType: 'arraybuffer'
})

/**
 * 设置审批人
 */
const setApply = (data) => axios({
  url: 'enterprise/review',
  method: 'put',
  data
})

/**
 * 删除企业用户
 */
const deleteUser = (uuid) => axios({
  url: `enterprise/user/${uuid}`,
  method: 'delete'
})

/**
 * 导出企业列表
 */
const getCompanyExcel = params => axios({
  url: 'enterprise/excel',
  responseType: 'arraybuffer',
  params
})

/**
 * 企业楼层列表
 */
const getFloorList = () => axios({
  url: 'enterprise/floor'
})

/**
 *更新第三方数据
 */
const updata = () => axios({
  url: 'enterprise',
  method: 'put'
})

/**
 * 放行记录
 */
const getReleaseLog = (data) => axios({
  url: `enterprise/release/${data.uuid}?pageSize=${data.pageSize}&pageIndex=${data.pageIndex}&type=${data.type}&status=${data.status}&word=${data.word}`
})

/**
 * 设置折扣
 */
export const setDiscount = (data) => axios({
  url: '/enterprise/discount',
  method: 'put',
  data
})

export {
  getCompanyList,
  getVisitorList,
  getVisitorDetails,
  getCompanyDetails,
  getCompanyUserList,
  getCompanyUserDetails,
  getExcel,
  setApply,
  deleteUser,
  getCompanyExcel,
  getFloorList,
  updata,
  getReleaseLog
}
